import { createReducer } from 'typesafe-actions'
import { setTextFilterState } from '../actions/app/equipmentFilter.actions'

export const defaultState = ''

const equipmentFilterReducer = createReducer(defaultState)
    .handleAction(setTextFilterState, (state, action) => action.payload)

export default equipmentFilterReducer
